import { Component, OnInit, NgZone } from '@angular/core';
import { UtilService } from 'src/app/services/util.service';
import { AlertService } from 'src/app/services/alert.service';
import { ModalController, AlertController } from '@ionic/angular';
import { DBService } from 'src/app/services/db.service';
import { ImageGalleryComponent } from 'src/app/components/image-gallery/image-gallery.component';
import { Special } from 'src/app/models/special.model';
import { SpecialDetailComponent } from 'src/app/components/special-detail/special-detail.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-edit-special',
  templateUrl: './edit-special.page.html',
  styleUrls: ['./edit-special.page.scss'],
})
export class EditSpecialPage implements OnInit {

  constructor(public db: DBService, public util: UtilService, private ngZone: NgZone, private router: Router,
    private modalController: ModalController, private alert: AlertService) { }

  ngOnInit() {
    if (!this.db.currentRestaurantKey) {
      this.ngZone.run(() => this.router.navigate(['/restaurant-list']))
      return
    }
  }


  back() {
    this.ngZone.run(() => this.router.navigate(['/owner-home']))
  }
  
  
  async deleteSpecial(specialObj: Special) {
    this.alert.presentAlertConfirm(this, (ref) => {
      ref.db.currentRestaurant.special2 = ref.util.deleteFromArray(ref.db.currentRestaurant.special2, specialObj)
      ref.save();
    }, 'Special löschen?', 'Möchtest du dieses Special wirklich löschen?')
  }

  async openSpecialDetails(specialObj?: Special) {
    const modal = await this.modalController.create({
      component: SpecialDetailComponent,
      componentProps: { specialObj: specialObj?(Object.assign({}, specialObj)):undefined }
    });

    await modal.present();
    await modal.onDidDismiss().then((res: any) => {
      this.util.isModalOpen = false
      if (res && res.data) {
        if (!specialObj) {
          if (!this.db.currentRestaurant.special2) this.db.currentRestaurant.special2 = []
          this.db.currentRestaurant.special2.push(res.data)
        }else{
          this.db.currentRestaurant.special2[this.db.currentRestaurant.special2.indexOf(specialObj)] = res.data
        }
        this.save()
      }
    })
  }

  getImgUrl(img: string) {
    let url: string = ''
    if (img){
      if(img.includes("http")) url = img
      else url = "/" + img
    }else
      url = "/assets/imgs/specials/special_15.jpg"

    return 'url(' + url + ')'
  }

  changeActiveState(specialObj:Special){
    specialObj.isActive = !specialObj.isActive
    this.save()
  }

  save() {
    this.db.updateRestaurant(this.db.currentRestaurantKey)
    this.util.presentToast("Änderungen wurden gespeichert")
  }

}
